export default function getUserRole(currentUser, currentChapter) {
  const userRole = currentUser.getIn(['data', 'role'], '');
  const chapterUserRole = currentChapter.getIn(['data', 'userRole'], '');
  return userRole || chapterUserRole;
}
